import React from 'react';
import './ManageColumnsModal.css';

const ManageColumnsModalHeader = (props) => {
  return (
    <div id="ManageColumnsModalList_HeaderDiv" className="ManageColumnsModalList_HeaderDiv">
      <div id="ManageColumnsModalList_HeaderDiv_Title" className="ManageColumnsModalList_HeaderDiv_Title">
        Manage Columns
      </div>
    </div>
  );
};

export default ManageColumnsModalHeader;
